import React from 'react';
import { ArrowRight } from 'lucide-react';

export const QuickActionCard = (props) => {
  const Icon = props.icon;
  const { title, subtitle, onClick, testid } = props;
  return (
    <button
      type="button"
      onClick={onClick}
      data-testid={testid}
      className="group flex min-h-[112px] w-full flex-col justify-between rounded-2xl border border-border/60 bg-card/60 p-3 text-left transition-all hover:border-primary/60 hover:bg-card active:scale-[0.98] sm:p-5"
    >
      <div className="flex items-start justify-between">
        <span className="flex h-8 w-8 items-center justify-center rounded-xl bg-primary/15 text-primary transition-colors group-hover:bg-primary/25 sm:h-10 sm:w-10">
          {Icon && <Icon className="h-4 w-4 sm:h-5 sm:w-5" />}
        </span>
        <ArrowRight className="h-3.5 w-3.5 text-muted-foreground transition-transform group-hover:translate-x-0.5 group-hover:text-primary sm:h-4 sm:w-4" />
      </div>
      <div className="mt-3">
        <h3 className="text-xs font-semibold leading-tight sm:text-base">{title}</h3>
        <p className="mt-0.5 hidden text-xs text-muted-foreground line-clamp-2 sm:block">{subtitle}</p>
      </div>
    </button>
  );
};

export default QuickActionCard;
